import { useQuery, type UseQueryOptions } from "@tanstack/react-query";
import { exonnHubProductQueries } from "src/admin/modules/b2b-gate-order/components/ExonnHub/queries.ts";
import type { GetCatalog } from "@exonn/js-sdk";

export const useExonnHubCatalog = (
  params: GetCatalog.QueryParameters,
  options: Omit<
    UseQueryOptions<
      GetCatalog.Responses.$200,
      any,
      GetCatalog.Responses.$200,
      any
    >,
    "queryFn" | "queryKey"
  >,
) => {
  return useQuery({
    ...exonnHubProductQueries.list(params),
    gcTime: 0,
    staleTime: 0,
    ...options,
  });
};
